import styled from "styled-components"
import theme from "../theme"

const Select = styled<any, "select">("select")`
  border: solid 1px ${theme.colors.inputBorder};
  outline: none;
  font-family: ${theme.fonts.secondary};
  font-size: 1.25rem;
  padding-left: 10px;
  padding-right: 10px;
  padding-top: 0.25rem;
  :focus {
    border: solid 1px ${theme.colors.success};
  }
`

export default Select
